import React, { useState, useEffect } from "react";
import "./deathDashboard.css";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../redux/slices/loginSlice";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";

import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const EmailTextDashboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [emails, setEmails] = useState([]);
  const [texts, setTexts] = useState([]);

  const [loading, setLoading] = useState(false);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const getEmails = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.fetchEmail(ID);
      if (data && data.data) {
        setEmails(data.data);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getText = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.fetchText(ID);
      if (data && data.data) {
        setTexts(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (props.role !== "trustee") {
      getEmails();
      getText();
    }
  }, []);

  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "1rem",
        marginBottom: "1rem",
        height: "25%",
        cursor: "pointer",
        pointerEvents: props.role === "trustee" ? "none" : "",
        opacity: props.role === "trustee" ? "0.5" : "1",
      }}
      onClick={() => {
        if (props.role !== "protrustee") {
          dispatch(setActiveStep(5));
        } else {
          dispatch(setActiveStep(4));
        }
        history.push("/protector/death");
      }}
    >
      {" "}
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        Emails
        <ToolTipCreator name={"Death_Emails_and_Texts_to_Send_After_Death"}/>
      </div>
        <div className="uploadButtons" style={{ width: "20px" }}>
          {" "}
          <div className="upload" style={{ width: "20px", height: "20px" }}>
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div
        style={{
          height: "15rem",
          overflowY: "auto",
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {props.role !== "trustee" ? (
          <React.Fragment>
            <div
              style={{
                height: "7rem",
                overflowY: "auto",
                display: "flex",
                // justifyContent: "center",
                flexDirection: "column",
              }}
            >
              {emails && emails.length > 0 ? (
                emails.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #E8E9FF",
                      marginTop: "1rem",
                      marginBottom: "8px",
                      paddingBottom: "8px",
                    }}
                  >
                    <div className="checkListName">{item.to}</div>
                    <div className="emailStatus">
                      {item.status ? item.status : "Not Sent"}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "700",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    marginTop: "2rem",
                  }}
                >
                  No data to show
                </div>
              )}
            </div>
            <div
            className="cardHeading"
            style={{
              marginTop: "8px",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            Texts
          </div>
            <div
              style={{
                height: "7rem",
                overflowY: "auto",
                display: "flex",
                // justifyContent: "center",
                flexDirection: "column",
              }}
            >
             
              {texts && texts.length > 0 ? (
                texts.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #E8E9FF",
                      marginTop: "1rem",
                      marginBottom: "8px",
                      paddingBottom: "8px",
                    }}
                  >
                    <div className="checkListName">{item.to}</div>
                    <div className="emailStatus">
                      {item.status ? item.status : "Not Sent"}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "700",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    marginTop: "2rem",
                  }}
                >
                  No data to show
                </div>
              )}
            </div>
          </React.Fragment>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection: "column",
              marginTop: "2rem",
            }}
          >
            This information will be available to you soon!
            <img
              src={protectedImg}
              style={{ width: "50px", height: "50px", marginTop: "8px" }}
              alt="protectedImg"
            ></img>
          </div>
        )}
      </div>
    </div>
  );
};
